import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoMdChatbubbles } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';

const INITIAL_CONTEXT = `You're Jacks AI. your role is to help website visitors understand what Jacks is personal Drivers booking app.

The APP is coming soon. Clients and drivers should just register for early access and they will receive announcements and updates on the date.

Always give brief answers with cta. Be helpful and polite.

About Us
Welcome to Jacks – Revolutionizing the Personal Driver Experience
Jacks is changing the way people think about personal transportation. With our on-demand
marketplace app, you can hire professional drivers to drive you in the comfort of your own
car – no long-term commitments, no hassle, and entirely on your schedule.
We are committed to creating a service that puts you first. Everything we do is designed to
simplify your life, elevate your experience, and empower the Jacks community of drivers
and clients alike.
What We Do
Jacks provides a modern solution to personal transportation. Whether it's for daily errands,
a special event, or simply getting home safely, our app connects you with vetted,
professional drivers who come to you. They take the wheel of your car so you can focus on
what matters most.
Forget about hiring full-time drivers or spending on costly chauEeur services. With Jacks,
you get the flexibility of booking a driver when you need one, without any long-term
obligations.
How It Works
1. Book a Driver on Demand:
Open the Jacks app, enter your pickup location, time, and duration, and request a driver
instantly.
2. Professional Drivers Come to You:
A qualified driver arrives at your location, ready to drive your car wherever you need to go.
3. Enjoy a Seamless Experience:
Relax while your driver takes care of the journey, oEering a safe, professional, and
convenient ride.
4. Transparent Pricing and Secure Payments:
Payments are processed directly through the app, with clear, upfront pricing. No hidden
fees or surprises.
Why Jacks is Di\erent
• On-Demand Flexibility: No commitments, no contracts – book a driver
when you need one, for as little as 3 hours.
• Safe and Reliable: All Jacks drivers are carefully vetted and trained to ensure
your safety and satisfaction.
• Convenient and A\ordable: Experience the luxury of a personal driver at a
fraction of the cost of traditional services.
• Community-Driven: Jacks empowers drivers to earn on their terms while
delivering exceptional service to clients.
Everything We Do is for You
At Jacks, our clients are at the heart of everything we do. We're here to simplify your life and
provide a premium experience with every ride. By empowering our drivers and fostering a
strong community, we're creating a transportation service that benefits everyone.
Ready for a new way to ride? Download Jacks today and experience the future of
personal driving.

Links: Only Provide links when asked. Try to keep the answer short and concise.
Client Registration: https://bookjacks.com/client
Driver Registration: https://bookjacks.com/chauffeur    
Careers: https://bookjacks.com/career

Contact: concierge@jacks.com.co or (877) 774-1701
JACKS APP INC || 228 Park Ave S #651386 New York NY 10003|| P: (877) 774-1701`;

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    // Add user message to chat
    const userMessage = { role: 'user', content: message };
    setMessages(prev => [...prev, userMessage]);
    setMessage('');
    setIsLoading(true);

    try {
      // Call Gemini AI API
      const response = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash-exp:generateContent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-goog-api-key': import.meta.env.VITE_GEMINI_API_KEY,
        },
        body: JSON.stringify({
          contents: [{
            parts: [{
              text: `${INITIAL_CONTEXT}\n\nUser: ${message}`
            }]
          }],
          generationConfig: {
            temperature: 0.7,
            topK: 40,
            topP: 0.95,
            maxOutputTokens: 1024,
          }
        })
      });

      const data = await response.json();
      
      // Add AI response to chat
      if (data?.candidates?.[0]?.content?.parts?.[0]?.text) {
        const aiMessage = {
          role: 'assistant',
          content: data.candidates[0].content.parts[0].text
        };
        setMessages(prev => [...prev, aiMessage]);
      }
    } catch (error) {
      console.error('Error:', error);
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: 'Sorry, I encountered an error. Please try again.'
      }]);
    }

    setIsLoading(false);
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            className="absolute bottom-16 right-0 w-[calc(100vw-32px)] md:w-[400px] bg-black border border-gray-800 rounded-2xl shadow-xl overflow-hidden"
          >
            {/* Chat Header */}
            <div className="bg-[#111111] p-5 flex items-center justify-between border-b border-gray-800">
              <div>
                <h3 className="text-white font-medium text-lg">Chat Support</h3>
                <p className="text-gray-400 text-sm">AI Assistant</p>
              </div>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-white transition-colors p-2 -mr-2"
              >
                <IoClose size={24} />
              </button>
            </div>

            {/* Chat Messages */}
            <div className="h-[60vh] md:h-[400px] p-5 overflow-y-auto">
              {messages.map((msg) => (
                <div
                  key={`${msg.role}-${msg.content.substring(0, 20)}`}
                  className={`mb-4 ${msg.role === 'user' ? 'text-right' : 'text-left'}`}
                >
                  <div
                    className={`inline-block p-3.5 rounded-2xl max-w-[85%] text-base ${
                      msg.role === 'user'
                        ? 'bg-blue-500 text-white rounded-br-sm'
                        : 'bg-[#1A1A1A] text-white rounded-bl-sm'
                    }`}
                  >
                    {msg.content}
                  </div>
                </div>
              ))}
              {isLoading && (
                <div className="text-left mb-4">
                  <div className="inline-block p-4 rounded-2xl bg-[#1A1A1A] text-white rounded-bl-sm">
                    <div className="flex gap-2">
                      <div className="w-2.5 h-2.5 bg-gray-500 rounded-full animate-bounce" />
                      <div className="w-2.5 h-2.5 bg-gray-500 rounded-full animate-bounce [animation-delay:-.3s]" />
                      <div className="w-2.5 h-2.5 bg-gray-500 rounded-full animate-bounce [animation-delay:-.5s]" />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Chat Input */}
            <form onSubmit={handleSubmit} className="p-5 border-t border-gray-800">
              <div className="flex gap-3">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type your message..."
                  className="flex-1 bg-[#1A1A1A] text-white px-4 py-3 rounded-xl border border-gray-800 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors text-base placeholder:text-gray-500"
                />
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`px-5 py-3 rounded-xl text-white font-medium whitespace-nowrap transition-colors text-base ${
                    isLoading
                      ? 'bg-blue-500/50 cursor-not-allowed'
                      : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700'
                  }`}
                >
                  Send
                </button>
              </div>
            </form>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Chat Button */}
      <motion.button
        type="button"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className="bg-black hover:bg-gray-900 text-white p-3.5 rounded-xl shadow-lg flex items-center justify-center border border-gray-800"
      >
        <IoMdChatbubbles size={24} className="text-white/90" />
      </motion.button>
    </div>
  );
};

export default ChatWidget; 